// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"916b26ac","466":"b75825f6","738":"e60efe91","856":"828e262e"}[chunkId] + ".chunk.js";
};